import type { ItemSummary } from '@/types/item/ItemSummary';

export type ImageSearchStatus = 'idle' | 'analysing' | 'success' | 'error';

/**
 * Stable codes the UI maps to localized copy. `invalid-type` is the client-side pre-check;
 * everything else (BE 400 "can't decode", network failure, resize failure) is `request-failed`.
 */
export type ImageSearchErrorCode = 'invalid-type' | 'request-failed';

export type ImageSearchSlice = {
    error: ImageSearchErrorCode | null;
    results: ItemSummary[];
    status: ImageSearchStatus;
    // Object URL (blob:) for the uploaded image — the results-page thumbnail, this session only.
    thumbnailUrl: string | null;
};

export const defaultImageSearchSlice: ImageSearchSlice = {
    error: null,
    results: [],
    status: 'idle',
    thumbnailUrl: null,
};

/** Resolved value of the `submitImageSearch` thunk: hydrated cards + the object URL for the upload thumbnail. */
export type SubmitImageSearchResult = {
    results: ItemSummary[];
    thumbnailUrl: string;
};
